import ApiClient from '@softwaredev_cegeka/api-client'

class RuntimeConfigApi extends ApiClient {
    static BASE_URL = '/api/runtime-config'

    /**
     * @param {Object} params
     * @param {Symbol} [cancelId=null] Calls with the same Symbol as an ongoing call will cancel the ongoing call before starting a new one
     * @return {Promise<*>}
     */
    async fetchConfig(params = {}, cancelId = null) {
        return this.client.get('/', {
            cancelId,
            params: { key: params.key },
        })
    }
}

export default RuntimeConfigApi
